import { createContext } from 'react';

import { ModuleContextState } from './ModuleContextProvider.types';

export const ModuleContext = createContext<ModuleContextState | null>(null);
